import AbstractRuleTemplateAction from "./AbstractRuleTemplateAction.js";

/**
 * Action to perform in order to remove an existing rule template
 */
export default class RemoveRuleTemplateAction extends AbstractRuleTemplateAction {
	appendTo(bulkRuleTemplateAction) {
		bulkRuleTemplateAction.appendRemoveRuleAction({
			ruleTemplate: this._ruleTemplate,
		});
	}
}
